import LatestPhones from 'components/LatestPhones';

function App() {
  return <LatestPhones />;
}

export default App;
